import type { Node, UserComponent, NodeHelpersType } from '@craftjs/core';
import {
  FormSubmitButton as SharedFormSubmitButton,
  type FormSubmitButtonProps,
} from '@builder4/shared/components/Form';
import { FORM_SUBMIT_BUTTON_NODE_NAME } from '@/utils/constants';
import { InspectorForm } from '@/components/inspector/InspectorForm/InspectorForm';

const EditorFormSubmitButton: UserComponent<Partial<FormSubmitButtonProps>> = (props) => {
  return <SharedFormSubmitButton {...props} />;
};

EditorFormSubmitButton.craft = {
  ...SharedFormSubmitButton.craft,
  displayName: FORM_SUBMIT_BUTTON_NODE_NAME,
  related: {
    toolbar: InspectorForm,
  },
  rules: {
    canDrag: (node: Node) => {
      return !node.data.custom?.isLocked;
    },
    // Submit button should not accept children
    canMoveIn: () => false,
    // Prevent removing the last submit button from its parent
    canMoveOut: (outgoingNodes: Node[], self: Node, helpers: NodeHelpersType) => {
      const parentId = self.data.parent;
      if (!parentId) return false;
      const parent = helpers(parentId).get();
      if (!parent) return false;
      const siblingSubmitIds = parent.data.nodes.filter((childId: string) => {
        const child = helpers(childId).get();
        return child?.data.displayName === FORM_SUBMIT_BUTTON_NODE_NAME;
      });
      const movingIds = new Set(outgoingNodes.map((n) => n.id));
      const remaining = siblingSubmitIds.filter((id: string) => !movingIds.has(id));
      return remaining.length >= 1;
    },
  },
};

export default EditorFormSubmitButton;
